
import React from 'react';
import { Link } from 'react-router-dom';
interface ITableRowProps {
    key?: number;
    item?: any;
    tableNable?: string;
}

const TableRow: React.FC<ITableRowProps> = ({ key, item, tableNable }) => {
  return (
    <>
      <div key={key} className='audit-doc-tabe-row-frame'>
        <div className='audit-doc-tabe-row-cell'>
          {
            tableNable?.includes('updates') ? (
              <div className='audit-doc-tabe-row-cell-cont'>
                <div className='audit-doc-tabe-row-cell-cont-texts'>
                  {item.col1}
                </div>
              </div>
            ) : (
              <Link to={{
                pathname: `/monitor/ticket/${item.id}`,
              }}>
                <div className='audit-doc-tabe-row-cell-cont' style={{ cursor: 'pointer' }}>
                  <div className='audit-doc-tabe-row-cell-cont-text'>
                    {item.col1}
                  </div>
                </div>
              </Link>
            )
          }

        </div>
        <div className='audit-doc-tabe-row-cell'>
          <div className='audit-doc-tabe-row-cell-cont'>
            <div className='audit-doc-tabe-row-cell-cont-texts'>
              {item.col2}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TableRow;
